export var filterRegions = function filterRegions(regions, value) {
  return regions.filter(function (_ref) {
    var label = _ref.label;
    if (!label) return false;
    var labelRegion = label.toLowerCase();
    return value.length > 1 ? labelRegion.includes(value.toLowerCase()) : labelRegion.startsWith(value.toLowerCase());
  });
};